import Vue from "vue";
import { Component } from "vue-property-decorator";
import { companyRepository } from "@/repositories";
import { ICompany } from "@/models";
import { FileNames } from "@/enums";

@Component({
    name: "company",
    metaInfo: {
        title: "Company",
    },
})

export default class Company extends Vue {

    public loading: boolean = false;
    public loadingButton: boolean = false;

    public headers = [
        { text: "HR Name", value: "hrName", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "AAD Name", value: "aadName", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "HrReferenceId", value: "HrReferenceId", class: "nowrap", cellClass: "fixedHeight", sortable: true },
    ];

    public search = "";

    public fields: ICompany[] = [];

    get itemsPerPage(): number{
        return this.$store.getters["app/itemsPerPage"];
    }

    async mounted(): Promise<void> {
        this.loading = true;
        companyRepository.getAllWithRequestsNumber().then(res=> {
            this.fields = res;
            this.loading = false;
        }).catch (error => {
            this.loading = false;
            this.$emit("error", error);
        });
    }

    public handleItemsPerPage(itemsPerPage: number): void{
        this.$store.dispatch("app/updateItemsPerPage", itemsPerPage);
    }

    public async exportData(): Promise<void> {
        this.loadingButton = true;
        companyRepository.export("export").then(res=> {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', FileNames.Company)
            document.body.appendChild(link);
            link.click();
            this.loadingButton = false;
        }).catch (error => {
            this.$emit("error", error);
        });
    }
}
